import React, { FC } from 'react';
// A customizable radio button component with a label and support for checked state and change handling.

interface RadioButtonProps {
  name: string;
  checked: boolean;
  onChange: () => void;
  label: string;
  className?: string;
   style?: React.CSSProperties;
}

const RadioButton: FC<RadioButtonProps> = ({ name, checked, onChange, label, className,style }) => (
  <div className={`form-check ${className}`}>
    <input
      type="radio"
      name={name}
      className="form-check-input"
      checked={checked}
      onChange={onChange}
      style={style} 
    />
    <label className="form-check-label">{label}</label>
  </div>
);

export default RadioButton;
